{
  "alert": "Warnhinweis",
  "dismiss": "Schließen"
}
